const getters = {
    token: state => state.user.token,
    name: state => state.user.name,
    role: state => state.user.role,
    menus: state => state.permission.menus,
    shcools: state => state.permission.shcools,
    currentSchool: state => state.permission.currentSchool,
    questionInfo: state => state.questionInfo,
    currentRoleGroup: state => state.permission.currentRoleGroup,
    currentOrganizationId: state => state.permission.currentOrganizationId,
    currentOrganizationName: state => state.permission.currentOrganizationName
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js